import { api } from "..";

import { Settings } from "@/types/Settings";

export interface UpdateProviderSettingsParams {
  // null = close that feed (no provider); number = select; omitted = unchanged.
  liveProviderId?: number | null;
  lineProviderId?: number | null;
}

// Step-up protected on the backend; the axios interceptor transparently prompts
// for the master password and retries on a STEP_UP_REQUIRED response.
export const updateProviderSettings = async (
  params: UpdateProviderSettingsParams
): Promise<Settings> => {
  const res = await api.client.put("/settings/providers", params);
  return res.data;
};
